import type { FC } from 'react';

export interface ErrorIconProps {
    className?: string;
}

export const ErrorIcon: FC<ErrorIconProps> = ({ className }) => (
    <svg fill="none" className={className} viewBox="0 0 312 224">
        <path
            d="m305.835 102.823-.445.554-16.267 20.512-22.87 28.843-16.259 20.504-22.878 28.835-16.259 20.513-.403.495H80.123l.4027-.495 16.2589-20.513 22.8784-28.835 16.259-20.504 22.87-28.843 16.267-20.512.444-.554h130.332Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path d="m227.115 202.07-16.259 20.512H80.5254l16.2589-20.512H227.115Z" fill="#1A1A1A" />
        <path d="m227.115 202.07-16.259 20.512H80.5254l16.2589-20.512H227.115Z" fill="url(#a)" />
        <path
            d="m227.115 202.07-16.259 20.512H80.5254l16.2589-20.512H227.115Z"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path d="m266.252 152.73-16.259 20.504H119.662l16.259-20.504h130.331Z" fill="#1A1A1A" />
        <path d="m266.252 152.73-16.259 20.504H119.662l16.259-20.504h130.331Z" fill="url(#b)" />
        <path
            d="m266.252 152.73-16.259 20.504H119.662l16.259-20.504h130.331Z"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path d="m305.391 103.376-16.267 20.512H158.793l16.267-20.512h130.331Z" fill="#1A1A1A" />
        <path d="m305.391 103.376-16.267 20.512H158.793l16.267-20.512h130.331Z" fill="url(#c)" />
        <path
            d="m305.391 103.376-16.267 20.512H158.793l16.267-20.512h130.331Z"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M134.412 46.8207c.117.4446.092.9312-.084 1.4513-2.198 6.4516-26.888 18.5241-58.3323 28.2224-31.4439 9.6899-58.6343 13.6161-64.0875 9.5221-.4362-.3272-.7466-.7215-.8892-1.1494-.0252-.0755-.042-.151-.0588-.2265-.0839-.4111-.0419-.8557.1175-1.3339 2.198-6.4516 26.88-18.5325 58.3239-28.2224 31.4434-9.6899 58.6424-13.6078 64.0954-9.5221.403.3021.688.646.848 1.0319.033.0756.05.1427.075.2266h-.008Z"
            fill="#fff"
        />
        <path
            d="M134.412 46.8207c.117.4446.092.9312-.084 1.4513-2.198 6.4516-26.888 18.5241-58.3323 28.2224-31.4439 9.6899-58.6343 13.6161-64.0875 9.5221-.4362-.3272-.7466-.7215-.8892-1.1494-.0252-.0755-.042-.151-.0588-.2265-.0839-.4111-.0419-.8557.1175-1.3339 2.198-6.4516 26.88-18.5325 58.3239-28.2224 31.4434-9.6899 58.6424-13.6078 64.0954-9.5221.403.3021.688.646.848 1.0319.033.0756.05.1427.075.2266h-.008Z"
            fill="url(#d)"
        />
        <path
            d="M134.412 46.8207c.117.4446.092.9312-.084 1.4513-2.198 6.4516-26.888 18.5241-58.3323 28.2224-31.4439 9.6899-58.6343 13.6161-64.0875 9.5221-.4362-.3272-.7466-.7215-.8892-1.1494-.0252-.0755-.042-.151-.0588-.2265-.0839-.4111-.0419-.8557.1175-1.3339 2.198-6.4516 26.88-18.5325 58.3239-28.2224 31.4434-9.6899 58.6424-13.6078 64.0954-9.5221.403.3021.688.646.848 1.0319.033.0756.05.1427.075.2266h-.008Z"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M57.0246 14.9726c.9139-.2818 1.8807.2053 2.1518 1.0844l45.9376 149.142-3.644.834L55.8574 17.0806c-.2711-.8791.2533-1.8261 1.1672-2.108Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M134.378 46.7713c-.134-.2852-.386-.5285-.755-.7299-5.033-2.7266-31.905 2.2484-63.3405 11.9383C38.847 67.6696 13.8379 78.6934 11.212 83.7774c-.193.3776-.2601.7215-.2098 1.0236-.0755-.2517-.1846-.495-.2181-.7551-2.19806-18.7841 14.8914-51.4277 48.4914-61.7804 33.6-10.361 66.0925 6.9885 74.8595 23.7507.126.235.168.495.243.7467v.0084Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <mask id="e" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="10" y="19" width="125" height="66">
            <path
                d="M134.38 46.7694c-.134-.2853-.386-.5286-.755-.7299-5.033-2.7266-31.905 2.2484-63.3405 11.9382-31.4355 9.6899-56.4447 20.7137-59.0706 25.7978-.1929.3775-.2601.7215-.2097 1.0235-.0755-.2517-.1846-.495-.2182-.755-2.19801-18.7842 14.8914-51.4278 48.4914-61.7804 33.6-10.3611 66.0926 6.9884 74.8596 23.7507.126.2349.168.495.243.7467v.0084Z"
                fill="#fff"
            />
        </mask>
        <g mask="url(#e)" fill="#1A1A1A">
            <path d="M131.475 52.1221c-4.27-1.2501-26.133.6963-59.607 11.0154-33.4658 10.3191-52.6274 21.0241-55.4547 24.4554 0 0 .4111-.5033.7467-1.4849l-20.89828-7.1311c1.61079-4.7065 5.83071-10.7721 24.94198-20.0593 11.9048-5.7804 27.5931-11.7789 44.1624-16.8881 16.5693-5.1092 32.9121-8.9852 46.0079-10.9148 21.024-3.0957 27.929-.4614 31.906 2.5253l-13.256 17.6599c.822.6208 1.443.8054 1.451.8054v.0168ZM111.81 22.685c-3.808-1.4849-22.3996-.7299-50.0095 7.7855-27.6099 8.5154-43.3906 18.3563-45.7061 21.7288 0 0 .3608-.5285.5705-1.5268l-21.59459-4.6311c1.55206-7.2821 8.2385-13.7755 21.65329-21.0492C27.0595 19.388 40.7512 13.8341 55.2902 9.3541 69.8293 4.8741 84.276 1.7532 95.971.56189c15.193-1.54367 24.363.058727 29.749 5.2015L110.476 21.737c.739.7047 1.326.9396 1.334.9396v.0084Z" />
        </g>
        <path
            d="M119.815 168.159s-18.626-11.532-32.9048 9.92"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M97.3111 182.63s-6.4935-9.061-17.6431-2.45"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="m184.288 112.754 6.502 17.929-7.299 2.86-7.156-20.713c-7.148-20.6972-8.054-43.0301-2.668-64.2555.738-2.8944 1.317-5.3274 1.619-6.8878.025-.1259.201-.9061.201-.9061 2.299-8.2637 16.201-13.742 17.87-4.6981.805 4.3877-2.961 8.0287-6.007 10.1932-1.938 1.3759-4.27 2.1142-6.644 2.1561-5.135 21.3094-3.893 43.6758 3.582 64.3222Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M227.242 122.403c2.928 3.255 5.034 7.156 6.057 11.535 3.717 15.974-8.414 32.526-27.249 37.459-.075 15.194-12.735 29.565-30.94 33.802-20.739 4.832-40.815-5.311-44.859-22.652-4.036-17.341 9.497-35.311 30.236-40.144.553-.125 1.107-.251 1.661-.344 1.292-13.389 12.802-25.655 28.986-29.422.385-.092.771-.176 1.157-.251-1.887-2.526-3.272-5.412-4.01-8.574-3.381-14.5143 7.945-29.5483 25.294-33.5836 17.35-4.0438 34.154 4.4464 37.535 18.9603 3.28 14.1023-7.324 28.7003-23.86 33.2223l-.008-.008Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="m271.529 37.7688-6.158-2.1394c-2.827-.9815-5.831.2349-7.148 2.8944l-19.287 38.8854m-25.151-6.8277 17.601-39.2293c1.208-3.6746 4.975-5.6629 8.683-4.5555l6.167 1.8289"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M276.548 42.0227c1.577-.797 2.173-2.7853 1.334-4.4548-.839-1.6696-2.802-2.3827-4.379-1.5857-1.578.7887-2.165 2.7937-1.326 4.4633.839 1.6695 2.794 2.3826 4.371 1.5856v-.0084Zm-26.671-9.7324c1.577-.7886 2.164-2.7937 1.334-4.4549-.839-1.6695-2.803-2.3826-4.38-1.5856-1.577.7886-2.173 2.7853-1.334 4.4548.839 1.6696 2.802 2.3827 4.38 1.5857Z"
            fill="#1A1A1A"
            stroke="#1A1A1A"
            strokeWidth="2.93633"
            strokeLinejoin="round"
        />
        <path
            d="m219.598 87.2333-7.064-.9145c-3.314-.4278-6.502 1.8961-7.114 5.1848-.621 3.2886 1.569 6.3005 4.882 6.7283l4.002.5202"
            fill="#fff"
        />
        <path
            d="m219.598 87.2333-7.064-.9145c-3.314-.4278-6.502 1.8961-7.114 5.1848-.621 3.2886 1.569 6.3005 4.882 6.7283l4.002.5202"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path d="M228.341 102.116s-5.571 6.829-11.829 1.351Z" fill="#fff" />
        <path
            d="M228.341 102.116s-5.571 6.829-11.829 1.351"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M225.22 85.3124c1.108.1426 2.14-.646 2.282-1.7618.143-1.1158-.646-2.1394-1.761-2.282-1.116-.1426-2.148.646-2.291 1.7618-.142 1.1158.646 2.1393 1.77 2.2903v-.0083Zm-10.578-1.3672c1.116.1426 2.147-.646 2.29-1.7618.143-1.1158-.646-2.1393-1.77-2.282-1.124-.1426-2.139.646-2.282 1.7618-.143 1.1158.646 2.1394 1.762 2.282Z"
            fill="#1A1A1A"
        />
        <path
            d="m228.34 126.554 36.721-15.806-21.553-9.959c-2.743-.604-4.664-2.2563-4.79-4.4879-.193-3.3474 3.708-6.7116 8.708-7.5338 5-.8221 9.203 1.2249 9.396 4.5639.118 2.1058-1.384 4.2199-3.767 5.7049l20.177 9.1699c1.066.486 1.779 1.535 1.829 2.676.05 1.149-.579 2.173-1.594 2.626l-42.09 20.747"
            fill="#fff"
        />
        <path
            d="m228.34 126.554 36.721-15.806-21.553-9.959c-2.743-.604-4.664-2.2563-4.79-4.4879-.193-3.3474 3.708-6.7116 8.708-7.5338 5-.8221 9.203 1.2249 9.396 4.5639.118 2.1058-1.384 4.2199-3.767 5.7049l20.177 9.1699c1.066.486 1.779 1.535 1.829 2.676.05 1.149-.579 2.173-1.594 2.626l-42.09 20.747"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path d="m209.272 158.889 67.317 19.791-1.434 6.871-68.844-18.121" fill="#fff" />
        <path
            d="m209.272 158.889 67.317 19.791-1.434 6.871-68.844-18.121"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="m279.44 163.327-5.462 42.954c0 2.903-3.548 5.26-9.933 5.26-6.384 0-9.933-2.357-9.933-5.26l-5.462-42.954h30.79Z"
            fill="#1A1A1A"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M279.431 163.318c0 1.141-.596 2.215-1.67 3.163-2.542 2.282-7.726 3.834-13.716 3.834-5.991 0-11.175-1.552-13.717-3.834-1.066-.948-1.67-2.022-1.67-3.163 0-1.41.915-2.718 2.492-3.817 2.743-1.922 7.492-3.18 12.895-3.18 5.402 0 10.151 1.267 12.894 3.18 1.578 1.099 2.492 2.416 2.492 3.817Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M275.733 161.926v.352c-.151.352-.469.68-.688.864-1.51 1.359-5.285 2.928-10.99 2.928s-9.48-1.569-10.982-2.919c-.218-.202-.545-.52-.696-.864v-.747c.201-6.275 5.352-11.318 11.678-11.318 6.326 0 11.494 5.051 11.687 11.335v.36l-.009.009Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M265.264 136.323v17.626c0 .386-.714.696-1.594.696-.881 0-1.603-.319-1.603-.696v-15.756s-8.918-5.126-8.926-5.134c-.336-.193-.26-.965.176-1.737.436-.771 1.065-1.233 1.393-1.048l10.512 6.049h.042Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="m262.678 134.861-1.174 3.012m3.717-1.553-3.155 1.871m.026.983 3.129-.244"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="M282.093 184.783c.882-4.247-.426-8.109-2.921-8.627-2.495-.518-5.233 2.504-6.115 6.75-.881 4.247.427 8.109 2.922 8.627 2.495.518 5.232-2.504 6.114-6.75Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="m146.561 161.875 12.693-9.522c1.485-.999 3.07-1.838 4.748-2.375 6.913-2.214 14.271-.142 18.357 5.529l14.153 19.64c3.188 4.43 9.069 6.065 14.597 4.06l3.289-1.191c4.732-1.72 9.799-1.317 13.834 1.082l2.157 1.284-34.85 25.806-24.968-43.03c-1.669-2.869-5.495-3.632-8.54-1.686l-8.541 5.445"
            fill="#fff"
        />
        <path
            d="m146.561 161.875 12.693-9.522c1.485-.999 3.07-1.838 4.748-2.375 6.913-2.214 14.271-.142 18.357 5.529l14.153 19.64c3.188 4.43 9.069 6.065 14.597 4.06l3.289-1.191c4.732-1.72 9.799-1.317 13.834 1.082l2.157 1.284-34.85 25.806-24.968-43.03c-1.669-2.869-5.495-3.632-8.54-1.686l-8.541 5.445"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="m161.871 166.715-13.415 54.238-41.839-.604c2.198-3.482 5.646-6.519 9.816-8.641l2.055-1.049c6.544-3.33 11.855-8.188 15.018-13.717l15.772-27.61c.881-1.543 2.114-3.649 3.406-5.855 3.733-6.36 12.719-7.266 17.45-1.603.26.311 4.556 8.289 4.556 8.289"
            fill="#fff"
        />
        <path
            d="m161.871 166.715-13.415 54.238-41.839-.604c2.198-3.482 5.646-6.519 9.816-8.641l2.055-1.049c6.544-3.33 11.855-8.188 15.018-13.717l15.772-27.61c.881-1.543 2.114-3.649 3.406-5.855 3.733-6.36 12.719-7.266 17.45-1.603.26.311 4.556 8.289 4.556 8.289"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path d="M138.976 210.307s-6.175-3.977-18.876-.512Z" fill="#fff" />
        <path
            d="M138.976 210.307s-6.175-3.977-18.876-.512"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path
            d="m164.639 132.713-23.046 10.722c-1.426.662-2.005 2.391-1.275 3.783.512.974 1.552 1.544 2.651 1.46l40.337-3.154-.159-5.957-20.421-.453 1.905-6.393.008-.008Z"
            fill="#fff"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <path d="M156.242 139.108h6.494" stroke="#1A1A1A" strokeWidth="0.989962" strokeLinejoin="round" />
        <path
            d="m178.943 145.792-.168-.402c.957 2.257 2.735 4.58 4.824 5.864 3.18 1.963 8.004 4.01 11.729 1.552 8.003-5.277-5.076-15.168-13.742-12.937"
            fill="#fff"
        />
        <path
            d="m178.943 145.792-.168-.402c.957 2.257 2.735 4.58 4.824 5.864 3.18 1.963 8.004 4.01 11.729 1.552 8.003-5.277-5.076-15.168-13.742-12.937"
            stroke="#1A1A1A"
            strokeWidth="0.989962"
            strokeLinejoin="round"
        />
        <defs>
            <pattern id="a" patternContentUnits="objectBoundingBox" width="0.0572311" height="0.408998">
                <use xlinkHref="#f" transform="scale(.00011 .00082)" />
            </pattern>
            <pattern id="b" patternContentUnits="objectBoundingBox" width="0.0572311" height="0.409165">
                <use xlinkHref="#f" transform="scale(.00011 .00082)" />
            </pattern>
            <pattern id="c" patternContentUnits="objectBoundingBox" width="0.0572279" height="0.408998">
                <use xlinkHref="#f" transform="scale(.00011 .00082)" />
            </pattern>
            <pattern id="d" patternContentUnits="objectBoundingBox" width="0.0339475" height="0.0960672">
                <use xlinkHref="#g" transform="scale(.00007 .0002)" />
            </pattern>
        </defs>
    </svg>
);
